import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Constants
import {
    ACTION_CREATE,
    ACTION_DELETE,
    ACTION_UPDATE,
    DATA_EMPTY,
    DATA_FAILED,
    DATA_LOADED
} from "../../../../component/Constants";

// Types
import IntegrationType from "../../../../types/integration/IntegrationType";

// Utils
import { CSVLink } from "react-csv";
import * as dayjs from "dayjs";
import { findIntegrationValue } from "../../../../helpers/utils";
import ConditionalRender from "../../../../helpers/ConditionalRender";


function List(props: { loading: number, coPilot: IntegrationType[], refresh: Function, isAdmin: boolean }) {
    const [showCreate, setShowCreate] = useState<boolean>(false);

    function refresh() {
        props.refresh();
    }

    useEffect(() => {
        if (props.loading === DATA_LOADED) {
            // Hide create button if there's already an integration configured (i.e., has a URL) OR if user is not admin
            const hasIntegration = findIntegrationValue('url', props.coPilot, 'ai.provider');
            setShowCreate(props.isAdmin && !hasIntegration)
        }
    }, [props.loading, props.coPilot, props.isAdmin]);

    const data = [{
        name: findIntegrationValue('name', props.coPilot, 'ai.provider'),
        url: findIntegrationValue('url', props.coPilot, 'ai.provider'),
        model: findIntegrationValue('model', props.coPilot, 'ai.provider'),
        plainkey: findIntegrationValue('plainkey', props.coPilot, 'ai.provider'),
        enable: findIntegrationValue('enable', props.coPilot, 'ai.provider')
    }]

    return (
        <div className="col h-100">
            <div className="card">
                <div className="card-header">
                    <i className="fal fa-microchip-ai me-1" aria-hidden="true"/>
                    Co-Pilot
                    <span className="badge bg-info"
                          data-tooltip-id="global-tooltip" data-tooltip-content="Total Co-Pilot integration count">{data[0].url ? 1 : 0}</span>
                    <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                       data-bs-target="#collapseCoPilot" aria-expanded="false" aria-controls="collapseCoPilot"/>
                </div>
                <div id="collapseCoPilot" className="card-body collapse show">

                    {props.loading === DATA_EMPTY ? (
                        <div className="w-100 text-center text-muted my-3">
                            <i className="fal fa-ban fa-fw fa-2x"/>
                            <p>
                                <button type="button" className="btn btn-link" onClick={refresh}>Co-Pilot integration not
                                    found -
                                    Click to Refresh
                                </button>
                            </p>
                        </div>
                    ) : (
                        props.loading === DATA_FAILED ? (
                            <div className="w-100 text-center text-muted my-3">
                                <i className="fal fa-ban fa-fw fa-2x text-danger"/>
                                <p>
                                    <button type="button" className="btn btn-link" onClick={refresh}>Failed to Retrieve
                                        Co-Pilot - Click to Refresh
                                    </button>
                                </p>
                            </div>
                        ) : (
                            <React.Fragment>
                                <div className="row row-cols-1 row-cols-md-2 table-search">
                                    <div className="col col-md-12">
                                        <ConditionalRender if={showCreate}>
                                            <Link
                                                    to="/admin/integrations/co-pilot/create"
                                                    state={{
                                                        action: ACTION_CREATE,
                                                        coPilot: props.coPilot
                                                    }}
                                                    role="button"
                                                    className="btn btn-sm btn-success"
                                            >
                                                <i className="fal fa-plus-square fa-fw"/>
                                                <span>Create</span>
                                            </Link>
                                        </ConditionalRender>

                                        <CSVLink role="button"
                                                 headers={[{ label: 'URL', key: 'url' },
                                                     { label: 'Account', key: 'account' },
                                                     { label: 'Api Key', key: 'apikey' },
                                                     { label: 'DBmarlin URl', key: 'dbmarurl' },
                                                     { label: 'Enabled', key: 'enable' }]}
                                                 data={data}
                                                 download={`DBmarlin - ${dayjs.default().format('YYYY-MM-DD HH:mm')} - New Relic.csv`}
                                                 className="btn btn-sm btn-primary">
                                            <i className="fal fa-file-export fa-fw"/><span>Export</span>
                                        </CSVLink>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th scope="col">AI Provider</th>
                                            {/* <th scope="col">AI Endpoint</th> */}
                                            <th scope="col">Model</th>
                                            <th scope="col">Enabled</th>
                                            <th className="actions" scope="col">Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row">
                                                    {data[0].name}
                                                </th>
                                                {/* <td className="concatenate">
                                                    {data[0].url}
                                                </td> */}
                                                <td className="concatenate">
                                                    {data[0].model}
                                                </td>
                                                <td className="concatenate">
                                                    <div className='form-check form-switch'>
                                                        <input checked={data[0].enable}
                                                               type="checkbox"
                                                               id="enabled"
                                                               className="form-check-input"
                                                               disabled={true}
                                                               data-lpignore={true}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="actions">
                                                    {props.isAdmin && (
                                                        <>
                                                            <Link to="/admin/integrations/co-pilot/edit"
                                                                  state={{ action: ACTION_UPDATE, data }}
                                                                  role="button" className="btn btn-sm btn-primary">
                                                                <i className="fal fa-edit fa-fw"/><span>Edit</span>
                                                            </Link>
                                                            <Link to="/admin/integrations/co-pilot/delete"
                                                                  state={{ action: ACTION_DELETE, data }} role="button"
                                                                  className="btn btn-sm btn-danger">
                                                                <i className="fal fa-trash-alt fa-fw"/><span>Delete</span>
                                                            </Link>
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </React.Fragment>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}

List.propTypes = {
    loading: PropTypes.number.isRequired,
    coPilot: PropTypes.array.isRequired,
    refresh: PropTypes.func.isRequired,
};

export default List;
